import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import SvgIcon from "../../../../../parts/SvgIcon";
import submit from "submit-form";
import useClickOutside from "../../../../../hooks/useClickOutside";

const DateSelectorNew = ({ datesWithAnswers, selectedAnswer }) => {
  const { t } = useTranslation("athlete-portal");
  const dropdownRef = useRef(null);
  const [date, setDate] = useState(
    selectedAnswer ? moment(selectedAnswer.utcDate, "YYYYMMDD") : moment()
  );
  const [dropdownOpened, setDropdownOpened] = useState(false);
  useClickOutside(
    dropdownRef,
    () => {
      setDropdownOpened(false);
    },
    dropdownOpened
  );

  const mobileOptions = datesWithAnswers.map((date) => ({
    value: date._id,
    label: moment(date.utcDate, "YYYYMMDD").format("MMM D, YYYY"),
  }));

  useEffect(() => {
    if (selectedAnswer) {
      setDate(moment(selectedAnswer.utcDate, "YYYYMMDD"));
    }
  }, [selectedAnswer]);

  const handleAddYear = () => {
    setDate(date.clone().add(1, "year"));
  };

  const handleSubtractYear = () => {
    // I mean, this feature is coming out this year so what's the point lol
    if (date.year() > 2023) {
      setDate(date.clone().subtract(1, "year"));
    }
  };

  const handleOpen = (e) => {
    e.preventDefault();
    setDropdownOpened(!dropdownOpened);
  };

  const handleSelectAnswer = (answer) => {
    submit("/actions/refresh?", {
      method: "GET",
      body: {
        checkInDate: moment(answer.utcDate, "YYYYMMDD").format("YYYY-MM-DD"),
        checkInFrequency: answer.questionnaire.questionnaireFrequency,
        athleteSwitch: false,
      },
    });
    setDropdownOpened(false);
  };

  return (
    <details id="dropdown-double" role="list" open ref={dropdownRef}>
      <summary onClick={handleOpen}>
        <p>{moment(date).format("MMM YYYY")}</p>
        <SvgIcon
          src={
            dropdownOpened ? "/img/svg/angle-up.svg" : "/img/svg/angle-down.svg"
          }
        />
      </summary>

      <div className={dropdownOpened ? "opened" : ""}>
        <header>
          <span>
            <b>{date.format("YYYY")}</b>
          </span>
          <div>
            <button
              data-button-type="text-white"
              data-icon-only
              onClick={handleSubtractYear}
            >
              <SvgIcon src="/img/new-icons/arrow-left.svg" />
            </button>
            <button
              data-button-type="text-white"
              data-icon-only
              onClick={handleAddYear}
            >
              <SvgIcon src="/img/new-icons/arrow-right.svg" />
            </button>
          </div>
        </header>
        <ul role="listbox">
          {moment.months().map((monthName, index) => {
            const month = moment().year(date.year()).month(index);
            const diff = month.diff(moment().startOf("month"), "months");

            const monthAnswers = datesWithAnswers.filter(
              (stat) =>
                moment(stat.utcDate, "YYYYMMDD").month() === month.month() &&
                moment(stat.utcDate, "YYYYMMDD").year() === date.year()
            );

            return (
              <li key={`${date.year()}-month-${index}`}>
                <details open>
                  <summary>
                    <span>{monthName}</span>
                    <SvgIcon src="/img/new-icons/arrow-right.svg" />
                  </summary>
                  <ul role="list">
                    {monthAnswers.length ? (
                      monthAnswers.map((answerDate) => (
                        <li
                          onClick={() => {
                            handleSelectAnswer(answerDate);
                          }}
                          key={`${answerDate._id}`}
                        >
                          <span className="z-10">
                            <b>
                              {moment(answerDate.utcDate, "YYYYMMDD").format(
                                "MMM D, YYYY"
                              )}
                            </b>
                          </span>
                        </li>
                      ))
                    ) : (
                      <li>
                        <span>{t("checkinSummaryComponents.noData")}</span>
                      </li>
                    )}
                  </ul>
                </details>
              </li>
            );
          })}
        </ul>
      </div>
    </details>
  );
};

export default DateSelectorNew;
